<template>
    <div class="iframe" v-bind="cmsEditHelperAttrs">
        <div class="iframe--spanner">
            <iframe class="iframe--elem" :src="content.url" frameborder="0"></iframe>
        </div>
    </div>
</template>

<script>
    import cmsPlugin from 'vue/mixins/cms/cms-plugin';


    export default {
        mixins: [
            cmsPlugin,
        ],
    };
</script>



// WEBPACK FOOTER //
// index.vue?58db6a54